<script setup>
import { ref } from 'vue'
import axios from 'axios'
import {
  CContainer,
  CRow,
  CCol,
  CCard,
  CCardHeader,
  CCardBody,
  CFormTextarea,
  CButton,
  CListGroup,
  CListGroupItem,
  CSpinner
} from '@coreui/vue'

const query = ref('')
const results = ref([])
const loading = ref(false)

const sendQuery = async () => {
  if (!query.value.trim()) return

  loading.value = true
  try {
    // Calling the API at the new external virtual host
    const response = await axios.post('https://ein-api.solr.cz/search', { query: query.value })
    results.value = response.data
  } catch (error) {
    console.error('Error fetching search results:', error)
    // Mock result for demonstration if backend fails
    results.value = [
      {
        title: 'Sample Result',
        url: 'https://example.com',
        description: 'This is a sample description because the backend is not yet fully configured.'
      }
    ]
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <CContainer class="py-5">
    <CRow class="justify-content-center">
      <CCol :md="8">
        <CCard class="mb-4">
          <CCardHeader>
            <h2 class="mb-0">Backend Query Interface</h2>
          </CCardHeader>
          <CCardBody>
            <div class="mb-3">
              <CFormTextarea
                v-model="query"
                placeholder="Enter your query here..."
                rows="4"
                class="mb-3"
              />
              <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <CButton color="primary" @click="sendQuery" :disabled="loading">
                  <CSpinner v-if="loading" size="sm" class="me-2" />
                  Send Query
                </CButton>
              </div>
            </div>
          </CCardBody>
        </CCard>

        <CCard v-if="results.length > 0">
          <CCardHeader>
            <h4 class="mb-0">Search Results</h4>
          </CCardHeader>
          <CCardBody>
            <CListGroup flush>
              <CListGroupItem v-for="(result, index) in results" :key="index" class="py-3">
                <h5 class="mb-1">
                  <a :href="result.url" target="_blank" rel="noopener noreferrer">
                    {{ result.title }}
                  </a>
                </h5>
                <p class="mb-1 text-muted">{{ result.description }}</p>
                <small class="text-info">{{ result.url }}</small>
              </CListGroupItem>
            </CListGroup>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </CContainer>
</template>

<style scoped>
a {
  text-decoration: none;
  color: var(--cui-primary);
}
a:hover {
  text-decoration: underline;
}
</style>
